import axios from 'axios';
import { createMutation } from 'react-query-kit';

import { restUrl } from '@/services/utils';

import { MassUpdateRequestPayload, Selection } from './mass-update.types';

const useCreateSelection = createMutation({
    mutationFn: async ({ selection }: { selection: Selection }) => {
        const response = await axios.post(restUrl('selections'), selection);

        return response.data;
    }
});

const useMassUpdateResource = createMutation({
    mutationFn: async ({ data }: { data: MassUpdateRequestPayload }) => {
        const response = await axios.post(restUrl('items/massupdate'), data);
        return response.data;
    }
});

export { useCreateSelection, useMassUpdateResource };
